import { createRouter, createWebHistory } from "vue-router";

import LoginPage from "@/views/MainHomePages/LoginPage.vue";
const routes = [

  {
    path: "/Login-Page/:qrDisplayId",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/Web-Form/:qrDisplayId",
    name: "LandingPage",
    component: () =>
      import(
        /* webpackChunkName: "LandingPage" */ "../views/MainHomePages/LandingPage.vue"
      ),
  },
  {
    path: "/Report-Maintenance/:qrDisplayId",
    name: "ReportMaintenanceWithoutLogin",
    component: () =>
      import(
        /* webpackChunkName: "ReportMaintenanceWithoutLogin" */ "../components/Asset/Cards/ReportMaintenanceWithoutLogin.vue"
      ),

  },
   {
    path: "/Asset-Verification/:qrDisplayId",
    name: "AssetVerificationWithoutLogin",
    component: () =>
      import(
        /* webpackChunkName: "ReportMaintenanceWithoutLogin" */ "../components/Asset/Cards/AssetVerificationWithoutLogin.vue"
      ),

  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
